{
  "translation": {
    "aboutMirador": "மிரடோர்  திட்டம் பற்றி",
    "aboutThisItem": "இந்த உருப்படியைப் பற்றி",
    "addedFromUrl": "(உரலியிலிருந்து சேர்க்கப்பட்டது)",
    "addManifestUrl": "வள இருப்பிடம்",
    "addManifestUrlHelp": "ஒரு IIIF வளத்தின் உரலி",
    "addResource": "வளத்தைச் சேர்க்கவும்",
    "annotationCanvasLabel_1/1": "உருப்படி: [{{label}}]",
    "annotationCanvasLabel_1/2": "இடது: [{{label}}]",
    "annotationCanvasLabel_2/2": "வலது: [{{label}}]",
    "annotations": "குறிப்புரைகள்",
    "attribution": "பண்புக்கூறு",
    "attributionTitle": "உரிமைகள்",
    "authenticationFailed": "அடையாளச் சரிபார்ப்பு தோல்வியடைந்தது",
    "authenticationRequired": "முழு அணுகலுக்கு அடையாளச் சரிபார்ப்பு அவசியம்",
    "backToResults": "முடிவுகளுக்குத் திரும்பு",
    "book": "நூல்",
    "bottom": "கீழ்",
    "cancel": "நீக்குக",
    "canvasIndex": "சுட்டெண்",
    "changeTheme": "கருப்பொருளை மாற்றவும்",
    "clearSearch": "நீக்குக",
    "close": "மூடுக",
    "closeAddResourceForm": "படிவத்தை மூடுக",
    "closeAddResourceMenu": "வளங்கள் பட்டியலை மூடுக",
    "closeCompanionWindow": "பலகத்தை  மூடுக",
    "closeWindow": "சாளரத்தை மூடுக",
    "collapseSection": "\"{{section}}\" பகுதியைச் சுருக்குக",
    "collapseSidePanel": "பக்கப்பட்டையைச் சுருக்குக",
    "collection": "சேகரம்",
    "continue": "தொடரவும்",
    "copy": "நகல்",
    "currentItem": "தற்போதைய உருப்படி",
    "currentItem_1/1": "தற்போதைய உருப்படி",
    "currentItem_1/2": "இடது",
    "currentItem_2/2": "வலது",
    "dark": "அடர் கருப்பொருள்",
    "digitizedView": "எண்ணிம காட்சி",
    "dismiss": "நிராகரிக்குக",
    "displayNoAnnotations": "முன்னிறுத்தல் இல்லை",
    "downloadExport": "பணித்தளத்தை தரவிறக்கவும்",
    "downloadExportWorkspace": "பணித்தளத்தை தரவிறக்கவும்",
    "elastic": "மீள்ம",
    "elasticDescription": "வரம்பற்ற பணித்தளத்தில் சாளரங்களை சுதந்திரமாக நகர்த்த முடியும், அளவையும் மாற்றலாம். சாளரங்கள் ஒன்றின் மேல் ஒன்று வரலாம்.",
    "emptyResourceList": "உங்கள் வளப் பட்டியல் காலியாக உள்ளது",
    "error": "தவறு",
    "errorDialogConfirm": "சரி",
    "errorDialogTitle": "ஒரு தவறு ஏற்பட்டுள்ளது",
    "exitFullScreen": "முழுத்திரையிலிருந்து வெளியேறவும்",
    "expandSection": "\"{{section}}\" பகுதியை விரிவாக்குக",
    "expandSidePanel": "பக்கப்பட்டையை விரிவாக்குக",
    "exportCopied": "பணித்தள அமைப்பு உங்கள் நகல்நினைவியில் நகலெடுக்கப்பட்டது.",
    "fetchManifest": "சேர்க்க",
    "fullScreen": "முழுத்திரை",
    "gallery": "படத்தொகுப்பு",
    "hideZoomControls": "பெரிதாக்குதல் கட்டுப்பாடுகளை மறைக்கவும்",
    "highlightAllAnnotations": "முன்னிறுத்தல்: அனைத்தும்",
    "iiif_homepage": "இந்த வளம் பற்றி",
    "iiif_manifest": "IIIF விபரக் கோப்பு",
    "iiif_related": "தொடர்புடையவை",
    "iiif_renderings": "மாற்று வடிவங்கள்",
    "iiif_seeAlso": "மேலும் காண்க",
    "imageFailedToLoad": "படத்தை பதிவேற்றுவதில் சிக்கல். விவரங்களுக்கு முனையத்தைப் பார்க்கவும்",
    "import": "தரவிறக்கம்",
    "importWorkspace": "பணித்தள தரவிறக்கம்",
    "importWorkspaceHint": "தரவிறக்கவேண்டிய மிரடோர் 4 பணித்தள அமைப்பை இங்கே ஒட்டவும்",
    "item": "உருப்படி: {{label}}",
    "itemList": "உருப்படி பட்டியல்",
    "jsError": "தொழில்நுட்ப விவரங்கள்",
    "jsStack": "{{ stack }}",
    "language": "மொழி",
    "layer_hide": "அடுக்கை மறைக்கவும்",
    "layer_move": "அடுக்கை நகர்த்தவும்",
    "layer_moveToBackground": "அடுக்கை பின்னணிக்கு நகர்த்தவும்",
    "layer_moveToFront": "அடுக்கை முன்னணிக்கு நகர்த்தவும்",
    "layer_opacity": "அடுக்கின் தெளிவின்மை",
    "layer_show": "அடுக்கை காட்டவும்",
    "layers": "அடுக்குகள்",
    "light": "மென் கருப்பொருள்",
    "links": "இணைப்புகள்",
    "listAllOpenWindows": "சாளரத்திற்குச் செல்லவும்",
    "login": "புகுபதிகை",
    "logout": "விடுபதிகை",
    "manifestError": "வளத்தைச் சேர்க்க முடியாது:",
    "maximizeWindow": "சாளரத்தை பெரிதாக்கவும்",
    "minimizeWindow": "சாளரத்தைச் சிறிதாக்கவும்",
    "mirador": "மிரடோர்",
    "miradorResources": "மிரடோர் வளங்கள்",
    "miradorViewer": "மிரடோர் பார்வையாளர்",
    "more": "மேலும்...",
    "moreResults": "மேலும் முடிவுகள்",
    "mosaic": "மொசைக்",
    "mosaicDescription": "காணப்படும் சாளர எல்லைக்குள், சாளரங்களை ஒன்றையொன்று சார்ந்து நகர்த்தியும் அளவை மாற்றியும் கொள்ளலாம்.",
    "moveCompanionWindowToBottom": "கீழே நகர்த்தவும்",
    "moveCompanionWindowToRight": "வலதுபுறம் நகர்த்தவும்",
    "multipartCollection": "பல்பகுதி சேகரம்",
    "nextCanvas": "அடுத்த உருப்படி",
    "noItemSelected": "எந்த உருப்படியும் தேர்ந்தெடுக்கப்படவில்லை",
    "numItems_one": "{{number}} உருப்படி",
    "numItems_other": "{{number}} உருப்படிகள்",
    "off": "முடக்குக",
    "openCompanionWindow_annotations": "குறிப்புரைகள்",
    "openCompanionWindow_attribution": "உரிமைகள்",
    "openCompanionWindow_canvas": "சுட்டெண்",
    "openCompanionWindow_info": "தகவல்",
    "openCompanionWindow_layers": "அடுக்குகள்",
    "openCompanionWindow_search": "தேடல்",
    "openInCompanionWindow": "தனி பலகத்தில் திறக்கவும்",
    "openWindows": "தற்போது திறந்திருக்கும் சாளரங்கள்",
    "pagination": "{{current}} இல் {{total}}",
    "position": "நிலை",
    "previewWindowTitle": "{{title}}",
    "previousCanvas": "முந்தைய உருப்படி",
    "related": "தொடர்புடைய",
    "resource": "வளம்",
    "retry": "மீண்டும் முயற்சிக்கவும்",
    "right": "சரி",
    "rights": "உரிமம்",
    "scroll": "உருட்டவும்",
    "searchInputLabel": "தேடல் சொற்கள்",
    "searchNextResult": "அடுத்த முடிவு",
    "searchNoResults": "முடிவுகள் எதுவும் காணப்படவில்லை",
    "searchPreviousResult": "முந்தைய முடிவு",
    "searchResultsRemaining": "{{numLeft}} மீதமுள்ளன",
    "searchSubmitAria": "தேடலைச் சமர்ப்பிக்கவும்",
    "searchTitle": "தேடல்",
    "selectWorkspaceMenu": "பணித்தள வகையைத் தேர்ந்தெடுக்கவும்",
    "showCollection": "சேகரத்தை காட்டவும்",
    "showingNumAnnotations_one": "{{number}} குறிப்புரை காட்டப்படுகிறது",
    "showingNumAnnotations_other": "{{number}} குறிப்புரைகள் காட்டப்படுகின்றன",
    "showZoomControls": "பெரிதாக்குதல் கட்டுப்பாடுகளைக் காட்டு",
    "sidebarPanelsNavigation": "பக்கப்பட்டை பலகங்களை வழிசெலுத்தல்",
    "single": "தனி",
    "startHere": "இங்கிருந்து தொடங்குங்கள்",
    "suggestSearch": "இந்த ஆவணத்தில் \"{{ query }}\" என்பதைத் தேடவும்",
    "tableOfContentsList": "பொருளடக்கம்",
    "theme": "கருப்பொருள்",
    "thumbnailList": "சிறுபடப் பட்டியல்",
    "thumbnailNavigation": "சிறுபடங்கள்",
    "thumbnails": "சிறுபடங்கள்",
    "toggleWindowSideBar": "பக்கப்பட்டையை மாற்றவும்",
    "totalCollections_one": "{{count}} சேகரம்",
    "totalCollections_other": "{{count}} சேகரங்கள்",
    "totalManifests_one": "{{count}} விபரக் கோப்பு",
    "totalManifests_other": "{{count}} விபரக் கோப்புக்கள்",
    "tryAgain": "மீண்டும் முயற்சிக்கவும்",
    "untitled": "[Untitled]",
    "view": "பார்வை",
    "viewWorkspaceConfiguration": "பணித்தள உள்ளமைவைக் காண்க",
    "welcome": "மிரடோருக்கு வரவேற்கிறோம்",
    "window": "சாளரம்: {{label}}",
    "windowMenu": "சாளரக் காட்சிகள் மற்றும் சிறுபடக் காட்சி",
    "windowNavigation": "சாளர வழிசெலுத்தல்",
    "windowPluginButtons": "தேர்வுகள்",
    "windowPluginMenu": "சாளர தேர்வுகள்",
    "workspace": "பணித்தளம்",
    "workspaceFullScreen": "முழுத்திரை",
    "workspaceMenu": "பணித்தள அமைப்புகள்",
    "workspaceNavigation": "பணித்தள வழிசெலுத்தல்",
    "workspaceOptions": "பணித்தள தேர்வுகள்",
    "workspaceSelectionTitle": "பணித்தள வகையைத் தேர்ந்தெடுக்கவும்",
    "zoomIn": "பெரிதாக்குக",
    "zoomOut": "சிறிதாக்குக",
    "zoomReset": "பெரிதாக்கத்தை மீளமைக்க"
  }
}
